import Button from "@mui/material/Button";
import React from "react";
import DownloadIcon from "@mui/icons-material/Download";

const CustomDownloadButton = ({ doc }) => {
  const download = ({ fileName, documentTypeName }) => {
    fetch(
      `${process.env.REACT_APP_BASE_ENDPOINT}api/dayoff/download-document?fileName=${fileName}`
    ).then((response) => {
      response.blob().then((blob) => {
        const fileURL = window.URL.createObjectURL(blob);
        let alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = documentTypeName;
        alink.click();
      });
    });
  };
  return (
    <Button
      color="warning"
      variant="contained"
      loadingPosition="end"
      startIcon={<DownloadIcon />}
      onClick={() => download(doc)}
    >
      İndir
    </Button>
  );
};

export default CustomDownloadButton;
